import Control from "../../../../../common/Controls/Control";
import RCPROPrestationsInternationales from "./RCPROPrestationsInternationales";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROCommercesAlimentaires = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig, formState } =
    useRCPROQuestion({ company });

  const activityKey = "commerceAlimentaire";

  return (
    <div>
      <Control
        label={inputsConfig.commerceAlimentaireModaliteVente.label}
        type="checkBtnList"
        name="commerceAlimentaireModaliteVente"
        value={company.RCPRO.commerceAlimentaireModaliteVente}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.commerceAlimentaireModaliteVente.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
        info={<>Plusieurs réponses possibles</>}
      />
      <Control
        label={inputsConfig.commerceAlimentaireProduitFrais.label}
        type="btnList"
        name="commerceAlimentaireProduitFrais"
        value={company.RCPRO.commerceAlimentaireProduitFrais}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.commerceAlimentaireProduitFrais.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <RCPROPrestationsInternationales
        company={company}
        activityKey={activityKey}
      />
    </div>
  );
};

export default RCPROCommercesAlimentaires;
